import APSearchInput from './APSearchInput';

export { APSearchInput };

export default APSearchInput;
